import * as React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { ButtonType } from '@/components/atoms/button'
import { modalContainerStyle } from '@/components/pages/accommodation-management/list-layout'
import { FrontTabletInputField } from '../input/input-field'
import { FrontTabletButton } from '../button'
import { createSelfCheckinResponsiveStyle, FrontTabletResponsiveToken } from '@/utils/front-tablet-responsive-style'

type SubmitType = {
  isConfirmed: boolean
  billingAddress: string
}
export const useReceiptFormModal = () => {
  const [isShowDialog, setIsShowDialog] = React.useState(false)
  const [onClickButton, setOnClickButton] = React.useState<(params: SubmitType) => void>()

  const openReceiptFormModal = (): Promise<SubmitType> => {
    setIsShowDialog(true)
    return new Promise(resolve => setOnClickButton(() => resolve))
  }

  const onClose = (isConfirmed: boolean, billingAddress: string) => {
    setIsShowDialog(false)
    if (onClickButton) {
      onClickButton({ isConfirmed, billingAddress })
    }
  }

  const ReceiptFormModal: React.FC<{ billingAddress: string }> = props => {
    const { t } = useTranslation()
    const [billingAddress, setBillingAddress] = React.useState<string>(props.billingAddress)

    return isShowDialog ? (
      <div css={[modalContainerStyle, { display: 'flex' }]}>
        <div css={modalBodyContainerStyle}>
          <div css={modalMainContainerStyle}>
            <div css={creditCardWrapper}>
              <p css={labelStyle}>
                {t('You can change the name on the receipt')} <span css={RequireText}>※</span>
              </p>
              <FrontTabletInputField value={billingAddress} onChange={e => setBillingAddress(e.target.value)} />
            </div>
          </div>
          <div css={modalButtonSectionStyle}>
            <FrontTabletButton
              buttonType={ButtonType.NonStyle}
              onClick={() => onClose(false, billingAddress)}
              customCss={receiptFormButtonStyle}
            >
              {t('Cancel')}
            </FrontTabletButton>
            <FrontTabletButton
              isDisabled={billingAddress.length === 0}
              buttonType={billingAddress.length === 0 ? ButtonType.PrimaryDisabled : ButtonType.Primary}
              onClick={() => onClose(true, billingAddress)}
              customCss={receiptFormButtonStyle}
            >
              {t('Next')}
            </FrontTabletButton>
          </div>
        </div>
      </div>
    ) : (
      <></>
    )
  }
  return {
    openReceiptFormModal,
    ReceiptFormModal,
  }
}

const modalBodyContainerStyle = css({
  position: 'relative',
  margin: 'auto',
  minWidth: 700,
  maxWidth: 700,
  zIndex: 102,
  opacity: 1,
  background: '#FFF',
  borderRadius: 10,
  padding: 40,
  display: 'flex',
  flexDirection: 'column',
  gap: 32,
})

const modalMainContainerStyle = css({
  backgroundColor: '#F2F2F2',
  display: 'flex',
})

const modalButtonSectionStyle = css({
  display: 'flex',
  justifyContent: 'space-between',
})

const receiptFormButtonStyle = css(
  createSelfCheckinResponsiveStyle({
    landscape11: { fontSize: FrontTabletResponsiveToken.standardButtonFontSize.landscape11 },
    portrait: { fontSize: FrontTabletResponsiveToken.standardButtonFontSize.portrait },
    landscape13: { fontSize: FrontTabletResponsiveToken.standardButtonFontSize.landscape13 },
  }),
)

const creditCardWrapper = css({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  backgroundColor: 'white',
})

const labelStyle = css(
  {
    fontWeight: 'bold',
    color: '#272727',
    display: 'block',
  },
  createSelfCheckinResponsiveStyle({
    landscape11: { fontSize: FrontTabletResponsiveToken.formLabelFontSize.landscape11 },
    portrait: { fontSize: FrontTabletResponsiveToken.formLabelFontSize.portrait },
    landscape13: { fontSize: FrontTabletResponsiveToken.formLabelFontSize.landscape13 },
  }),
)

const RequireText = css(
  {
    color: '#F2A40B',
    fontWeight: 'bold',
  },
  createSelfCheckinResponsiveStyle({
    landscape11: { fontSize: 14 },
    portrait: { fontSize: 14 },
    landscape13: { fontSize: 18 },
  }),
)
